/*
 * Project: LegalPlace assistant
 * File: src/redux/actions/account_settings.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

const CREATE_FIREBASE_ID = 'LOAD_FIREBASE_ID_';
const LOAD_MAIL_FROM_FB = 'LMFFB';
const UPDATE_MAIL_FROM_INPUT = 'UMFI';
const SET_EXISTANT_IN_FIREBASE = 'SEIF';
const LOAD_FLAT_UI = 'LFUI';
const LOAD_OPTIONS = 'LOFB';

const EDITED_DOCUMENT = 'EDITED_DOCUMENT';
const SHOW_CONTACT_US = 'SHOW_CONTACT_US';

const SET_CARD_PAYMENT = 'SET_CARD_PAYMENT';
const SET_X3_PAYMENT = 'SET_X3_PAYMENT';
const SET_PAYPAL_PAYMENT = 'SET_PAYPAL_PAYMENT';
const SET_DIRECT_PAYMENT = 'SET_DIRECT_PAYMENT';

const SET_CREAT_ASSIST = 'SET_CREAT_ASSIST';

const SHOW_LOGIN_MODAL = 'SHOW_LOGIN_MODAL';
const SHOW_SINGUP_MODAL = 'SHOW_SINGUP_MODAL';

function showContactUs(val) {
  return {
    type: SHOW_CONTACT_US,
    val,
  };
}
function editedDocument(val) {
  return {
    type: EDITED_DOCUMENT,
    edited: val,
  };
}

function getFirebaseToken() {
  return {
    type: CREATE_FIREBASE_ID,
  };
}


function updateMailFromInput(val) {
  return {
    type: UPDATE_MAIL_FROM_INPUT,
    value: val,
  };
}


function isDBExistant(val) {
  return {
    type: SET_EXISTANT_IN_FIREBASE,
    val,
  };
}

function loadFlatUI(val) {
  return {
    type: LOAD_FLAT_UI,
    val,
  };
}

function loadOptions(val) {
  return {
    type: LOAD_OPTIONS,
    val,
  };
}


function loadMail(val) {
  return {
    type: LOAD_MAIL_FROM_FB,
    val,
  };
}

function setCardPayment(val) {
  return {
    type: SET_CARD_PAYMENT,
    val,
  };
}

function setX3Payment(val) {
  return {
    type: SET_X3_PAYMENT,
    val,
  };
}

function setPaypalPayment(val) {
  return {
    type: SET_PAYPAL_PAYMENT,
    val,
  };
}

function setDirectPayment(val){
  return {
      type: SET_DIRECT_PAYMENT,
      val
  }
}

function setCreatAssist(val) {
  return {
    type: SET_CREAT_ASSIST,
    val,
  };
}

function showLoginModal(val) {
  return {
    type: SHOW_LOGIN_MODAL,
    val,
  };
}

function showSingupModal(val) {
  return {
    type: SHOW_SINGUP_MODAL,
    val,
  };
}

export {
  CREATE_FIREBASE_ID,
  LOAD_MAIL_FROM_FB,
  UPDATE_MAIL_FROM_INPUT,
  SET_EXISTANT_IN_FIREBASE,
  LOAD_FLAT_UI,
  LOAD_OPTIONS,
  EDITED_DOCUMENT,
  SHOW_CONTACT_US,
  SET_CARD_PAYMENT,
  SET_X3_PAYMENT,
  SET_PAYPAL_PAYMENT,
  SET_DIRECT_PAYMENT,
  SET_CREAT_ASSIST,
  SHOW_LOGIN_MODAL,
  SHOW_SINGUP_MODAL,
  getFirebaseToken,
  updateMailFromInput,
  isDBExistant,
  loadFlatUI,
  loadOptions,
  loadMail,
  editedDocument,
  showContactUs,
  setCardPayment,
  setX3Payment,
  setPaypalPayment,
  setDirectPayment,
  setCreatAssist,
  showLoginModal,
  showSingupModal,
};



// WEBPACK FOOTER //
// ./src/redux/actions/account_settings.js